import { useLatestAnalysisDatestamp } from '@/components/NCCard/NCCard';

const useConservationLatestAnalysisDatestamp = () => {
  return useLatestAnalysisDatestamp({ date: '2024-10-01' });
};

export { useConservationLatestAnalysisDatestamp as useLatestAnalysisDatestamp };
